var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-breadcrumb',{attrs:{"page-title":_vm.pageTitle,"directory":_vm.directory,"icon":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }